<proffeo-ui-dialog [title]="title | translate">
  <div class="w-full">
    <div class="relative mb-4">
      <proffeo-ui-input
        [(value)]="search"
        variant="search"
        placeholder="placeholders.search-input"
      />
    </div>

    @if (projectParticipants?.length > 0) {
      <div>
        <div class="flex items-center">
          <div class="flex w-full items-center border-b border-proffeo-surface-off">
            <div class="flex items-center justify-center shrink-0 self-center">
              <mat-checkbox
                (change)="onSelectAllChange($event)"
                [checked]="allSelected()"
              ></mat-checkbox>
            </div>
            <proffeo-label class="ml-4 py-4">{{ 'ui-forms-select-all' | translate }}</proffeo-label>
          </div>
        </div>

        @for (projectParticipant of filteredProjectParticipants(); track projectParticipant.id) {
          <div class="flex items-center">
            <div class="flex items-center justify-center shrink-0 self-center">
              <mat-checkbox
                (change)="onParticipantChange($event, projectParticipant.id)"
                [checked]="isSelected(projectParticipant.id)"
                [disabled]="isLockedById(projectParticipant.id)"
              ></mat-checkbox>
            </div>
            <proffeo-avatar
              [user]="projectParticipant.user()"
              [size]="AvatarSize.SM"
              class="ml-4"
            ></proffeo-avatar>
            <div class="ml-2 flex w-full flex-col truncate py-2">
              <proffeo-label>
                {{ projectParticipant.user()?.firstName }} {{ projectParticipant.user()?.lastName }}
              </proffeo-label>
            </div>
          </div>
        }
      </div>
    }

    @if (filteredProjectParticipants()?.length === 0) {
      <p>
        {{ 'placeholders.no-results-found' | translate }}
      </p>
    }
  </div>

  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      (clicked)="close()"
      text="close"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="handleSaveClick()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
